import Vue from 'vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import i18n from './plugins/vuei18n'
import './plugins/loadScript'
import App from './App.vue'
import AbstractPage from './AbstractPage'
import utils from './utils'
import api from './api'
import './filter'

// utils
Vue.prototype.utils = utils

// api
Vue.prototype.api = api

// AbstractPage
Vue.mixin(AbstractPage)

/**
 * Vue初期化
 */
Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production'
new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
